import { render } from "./BottomBarTabletMore.vue?vue&type=template&id=06d6e9e9&scoped=true"
import script from "./BottomBarTabletMore.vue?vue&type=script&lang=js"
export * from "./BottomBarTabletMore.vue?vue&type=script&lang=js"

import "./BottomBarTabletMore.vue?vue&type=style&index=0&id=06d6e9e9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06d6e9e9"]])

export default __exports__